<template>
  <div>
    <q-dialog
    :visible="isVisible"
    :showFooter="false"
    title="查看手机号"
    width="400px"
    :innerScroll="false"
    :contentLoading="loading"
    @close="onCancel"
    @cancel="onCancel"
  >
    <div class="center">
      <div class="phone">{{phone}}</div>
      <div class="tips">{{time}}秒杀后关闭</div>
    </div>
  </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isCheckPhone: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ""
    }
  },
  computed: {
    isVisible: {
      get() {
       if (this.isCheckPhone) {
         this.countDown()
       }
        return this.isCheckPhone
      },
      set(val) {
        this.$emit('update:isCheckPhone', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      time: 10,
      timer: null
    }
  },
  methods: {
    onCancel(){
      this.isVisible = false
      clearInterval(this.timer)
      this.time = 10
    },
    countDown() {
      this.timer = setInterval(()=> {
        this.time--
        if (this.time == 0) {
          clearInterval(this.timer)
          this.isVisible = false
          this.time = 10
        }
      },1000)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .center {
    height: 100px;
    margin: auto;
    overflow: hidden;
    .phone {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      margin-top: 20px;
    }
    .tips {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>